module.exports = __webpack_public_path__ + "static/media/home_focused@2x.63ed9bc0.png";